import { ValidationResult, useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateCloudVideoAssetSubtitleRequest } from "../../../../../../../../common/api/master-api/assets/details/UpdateCloudVideoAssetSubtitleRequest";
import { UpdateCloudVideoAssetSubtitleResponse } from "../../../../../../../../common/api/master-api/assets/details/UpdateCloudVideoAssetSubtitleResponse";
import { useAssetsApi } from "../../../../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../../../common/CloudAssetQueryKey";

export interface ValidateCloudVideoAssetSubtitleParams {
    assetId?: string;
    subtitleLanguageId: string;
}

export interface UseEditCloudAsset {
    validateCloudVideoAssetSubtitle: SprintMutationResult<ValidateCloudVideoAssetSubtitleParams, ValidationResult>;
    updateCloudVideoAssetSubtitle: SprintMutationResult<
        UpdateCloudVideoAssetSubtitleRequest,
        UpdateCloudVideoAssetSubtitleResponse
    >;
}

export const useEditCloudVideoAssetSubtitle = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseEditCloudAsset => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const validateCloudVideoAssetSubtitle = useSprintMutation<ValidateCloudVideoAssetSubtitleParams, ValidationResult>({
        mutationFn: async ({ assetId, subtitleLanguageId }): Promise<ValidationResult> => {
            if (!assetId) {
                throw new Error("Asset ID is required to validate video asset subtitle.");
            }

            return assetsApi.validateCloudVideoAssetUniqueness({ assetId, subtitleLanguageId });
        }
    });

    const updateCloudVideoAssetSubtitle = useSprintMutation<
        UpdateCloudVideoAssetSubtitleRequest,
        UpdateCloudVideoAssetSubtitleResponse
    >({
        mutationFn: async ({ assetId, subtitleLanguageId }: UpdateCloudVideoAssetSubtitleRequest) => {
            if (!assetId) {
                throw new Error("Asset ID is required to update video asset subtitle.");
            }

            return assetsApi.updateCloudVideoAssetSubtitle({ assetId, subtitleLanguageId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.CloudAssetDetails, invalidationKey]
            });
        }
    });

    return {
        validateCloudVideoAssetSubtitle,
        updateCloudVideoAssetSubtitle
    };
};
